<template>
  <div style="padding-left: 10px">
    <KfTableTitle title="二返率报表导出"/>
    <div class="info-card">
      <div>
        <el-form inline>
          <el-form-item label="服务中心" label-width="80px" v-if="this.componentParam === 'repair_all_report_export'">
            <el-select v-model.trim="twofold.business_unit_id" placeholder="请输入服务中心" clearable filterable  class="input">
              <el-option v-for="item in businessUnitIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务模式" label-width="80px" required>
            <el-select v-model.trim="twofold.service_mode" placeholder="请输入服务模式" filterable clearable class="input">
              <el-option v-for="item in serviceModeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌" label-width="80px">
            <el-select v-model.trim="twofold.brand_id" placeholder="请输入品牌" clearable filterable class="input"
                       @Change="changeCatalogByBrand(twofold.brand_id)">
              <el-option v-for="item in brandList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类" label-width="80px">
            <el-select v-model.trim="twofold.catalog_id" placeholder="请输入品类" clearable filterable class="input">
              <el-option v-for="item in catalogList" :key="item.id" :label="item.catalog_name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" label-width="80px" required>
            <el-date-picker v-model.trim="twofold.start_time" placeholder="请输入开始时间" clearable filterable class="input" style="width: 200px;"/>
          </el-form-item>
          <el-form-item label="结束时间" label-width="80px">
            <el-date-picker v-model.trim="twofold.end_time" placeholder="请输入结束时间" clearable filterable
                            @change="checkDateRange(twofold.start_time,twofold.end_time)" class="input" style="width: 200px;"/>
          </el-form-item>
          <el-form-item>
            <el-button :loading="twofoldLoading" @click="twofoldExport" type="primary" style="margin-left: 15px">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <KfTableTitle title="产能报表导出"/>
    <div class="info-card">
      <div>
        <el-form inline>
          <el-form-item label="服务中心" label-width="80px" v-if="this.componentParam === 'repair_all_report_export'">
            <el-select v-model.trim="capacity.business_unit_id" placeholder="请输入服务中心" clearable filterable class="input"
                       @Change="changeUserList(capacity.business_unit_id)">
              <el-option v-for="item in businessUnitIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" label-width="80px" required>
            <el-select v-model.trim="capacity.user_id" placeholder="请输入姓名" clearable filterable class="input">
              <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工站" label-width="80px">
            <el-select v-model.trim="capacity.station_id" placeholder="请输入工站" clearable filterable class="input">
              <el-option v-for="item in stationList" :key="item.id" :label="item.station_name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌" label-width="80px">
            <el-select v-model.trim="capacity.brand_id" placeholder="请输入品牌" clearable filterable class="input"
                       @Change="changeCatalogByBrand(capacity.brand_id)">
              <el-option v-for="item in brandList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类" label-width="80px">
            <el-select v-model.trim="capacity.catalog_id" placeholder="请输入品类" clearable filterable class="input">
              <el-option v-for="item in catalogList" :key="item.id" :label="item.catalog_name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" label-width="80px" required>
            <el-date-picker v-model.trim="capacity.start_time" placeholder="请输入开始时间" clearable filterable class="input" style="width: 200px"/>
          </el-form-item>
          <el-form-item label="结束时间" label-width="80px" style="margin-left: 15px">
            <el-date-picker v-model.trim="capacity.end_time" placeholder="请输入结束时间" clearable filterable
                            @change="checkDateRange(capacity.start_time,capacity.end_time)" class="input" style="width: 200px;"/>
          </el-form-item>
          <el-form-item>
            <el-button :loading="capacityLoading" @click="capacityExport" type="primary" style="margin-left: 15px">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <KfTableTitle title="进出存报表导出"/>
    <div class="info-card">
      <div>
        <el-form inline>
          <el-form-item label="服务中心" label-width="80px" v-if="this.componentParam === 'repair_all_report_export'">
            <el-select v-model.trim="inOutSave.business_unit_id" placeholder="请输入服务中心" clearable filterable class="input">
              <el-option v-for="item in businessUnitIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务模式" label-width="80px" required>
            <el-select v-model.trim="inOutSave.service_mode" placeholder="请输入服务模式" clearable filterable class="input">
              <el-option v-for="item in serviceModeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌" label-width="80px">
            <el-select v-model.trim="inOutSave.brand_id" placeholder="请输入品牌" clearable filterable class="input" @Change="changeCatalogByBrand(inOutSave.brand_id)">
              <el-option v-for="item in brandList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类" label-width="80px">
            <el-select v-model.trim="inOutSave.catalog_id" placeholder="请输入品类" clearable filterable class="input">
              <el-option v-for="item in catalogList" :key="item.id" :label="item.catalog_name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月份" label-width="80px">
            <el-date-picker v-model.trim="inOutSave.month" placeholder="请输入月份" clearable filterable class="input" style="width: 200px;"/>
          </el-form-item>
          <el-form-item>
            <el-button :loading="inOutSaveLoading" @click="inOutSaveExport" type="primary" style="margin-left: 15px">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <KfTableTitle title="修复率报表导出"/>
    <div class="info-card">
      <div>
        <el-form inline>
          <el-form-item label="服务中心" label-width="80px" v-if="this.componentParam === 'repair_all_report_export'">
            <el-select v-model.trim="repairRate.business_unit_id" placeholder="请输入服务中心" clearable filterable class="input">
              <el-option v-for="item in businessUnitIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌" label-width="80px">
            <el-select v-model.trim="repairRate.brand_id" placeholder="请输入品牌" clearable filterable class="input" @Change="changeCatalogByBrand(repairRate.brand_id)">
              <el-option v-for="item in brandList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类" label-width="80px">
            <el-select v-model.trim="repairRate.catalog_id" placeholder="请输入品类" clearable filterable class="input">
              <el-option v-for="item in catalogList" :key="item.id" :label="item.catalog_name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" label-width="80px" required>
            <el-date-picker v-model.trim="repairRate.start_time" placeholder="请输入开始时间" clearable filterable class="input" style="width: 200px;"/>
          </el-form-item>
          <el-form-item label="结束时间" label-width="80px">
            <el-date-picker v-model.trim="repairRate.end_time" placeholder="请输入结束时间" clearable filterable
                            @change="checkDateRange(repairRate.start_time,repairRate.end_time)" class="input" style="width: 200px;"/>
          </el-form-item>
          <el-form-item>
            <el-button :loading="repairRateLoading" @click="repairRateExport" type="primary" style="margin-left: 15px">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "RepairReportExport",
  props: {
    componentParam: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      twofoldLoading: false,
      capacityLoading: false,
      inOutSaveLoading: false,
      repairRateLoading: false,
      businessUnitIdList: [],
      brandList: [],
      catalogList: [],
      stationList: [],
      userList: [],
      twofold: {},
      capacity: {},
      inOutSave: {},
      repairRate: {},
    }
  },
  computed: {
    serviceModeList() {
      return this.$store.getters['core/getDictList']('repair_service_mode');
    }
  },
  created() {
    this.getBrandList()
    this.getStationList()
    this.getBusinessUnitIdList()
    this.getUserList()
  },
  methods: {

    async getBusinessUnitIdList() {
      this.businessUnitIdList = await this.$http('repairBusinessUnitService.getBusinessUnitDataSource')
    },

    //获取品牌
    async getBrandList() {
      this.brandList = await this.$http('repairDsService.getAllBrand')
    },
    //根据品牌获取品类
    async changeCatalogByBrand(brandId) {
      this.catalogList = await this.$http('repairCatalogService.getCatalogList', {brand_id: brandId})
    },
    //获取工站
    async getStationList() {
      this.stationList = await this.$http('repairStationService.getStationDataSource')
    },
    //获取人员姓名
    async getUserList(business_unit_id) {
      if (!business_unit_id && this.componentParam !== 'repair_all_report_export'){
        this.userList = await this.$http('repairUserService.getUserList', {repair_base_access: 'repair_base_access'})
      }else{
        this.userList = await this.$http('repairUserService.getBusinessUnitUserList',
            {business_unit_id: business_unit_id, repair_base_access: 'repair_base_access'})
      }
    },

    //根据服务中心获取人员
    async changeUserList(business_unit_id){
      await this.getUserList(business_unit_id)
    },

    //时间范围不能超过一个月
    checkDateRange(start_time, end_time) {
      if (end_time && start_time) {

        let endTime = new Date(end_time)
        let previousDate = new Date(endTime.setDate(end_time.getDate() - 31));
        if (previousDate > start_time) {
          return this.$message.error('时间范围不能超过一个月')
        }
      }
    },

    //导出Excel
    excelExport(file) {
      const url = file.url;
      const originalName = file.originalName;

      if (url) {
        const link = document.createElement('a');
        link.href = url;
        link.download = originalName || '' // 下载文件的名字
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      }
      return this.$message.success('导出成功')
    },

    //二返率
    async twofoldExport() {

      if (!this.twofold.service_mode) {
        return this.$message.error('请输入服务模式')
      }
      if (!this.twofold.start_time) {
        return this.$message.error('请选择开始时间')
      }
      if (!this.twofold.end_time) {
        this.twofold.end_time = new Date()
      }
      let endTime = new Date(this.twofold.end_time)
      let previousDate = endTime.setDate(this.twofold.end_time.getDate() - 31)
      if (previousDate > this.twofold.start_time) {
        return this.$message.error('时间范围不能超过一个月')
      }
      this.twofoldLoading = true
      this.twofold.is_one = this.componentParam !== 'repair_all_report_export';

      await this.$http('repairReportExportService.twofoldExport', this.twofold, false).then(data => {
        this.twofoldLoading = false
        this.excelExport(data)

      }, errMsg => {
        this.twofoldLoading = false;
        return this.$message.error(errMsg);
      })
    },

    //产能
    async capacityExport() {

      if (!this.capacity.user_id) {
        return this.$message.error('请输入姓名')
      }
      if (!this.capacity.start_time) {
        return this.$message.error('请选择开始时间')
      }
      if (!this.capacity.end_time) {
        this.capacity.end_time = new Date()
      }
      let endTime = new Date(this.capacity.end_time)
      let previousDate = endTime.setDate(this.capacity.end_time.getDate() - 31)

      if (previousDate > this.capacity.start_time) {
        return this.$message.error('时间范围不能超过一个月')
      }
      this.capacityLoading = true
      this.capacity.is_one = this.componentParam !== 'repair_all_report_export';

      await this.$http('repairReportExportService.capacityExport', this.capacity, false).then(data => {
        this.capacityLoading = false
        this.excelExport(data)

      }, errMsg => {
        this.capacityLoading = false;
        return this.$message.error(errMsg);
      })
    },

    //进出存
    async inOutSaveExport() {

      if (!this.inOutSave.service_mode) {
        return this.$message.error('请输入服务模式')
      }
      if (!this.inOutSave.month) {
        return this.$message.error('请选择月份')
      }
      this.inOutSaveLoading = true
      this.inOutSave.is_one = this.componentParam !== 'repair_all_report_export';

      await this.$http('repairReportExportService.inOutSaveExport', this.inOutSave, false).then(data => {
        this.inOutSaveLoading = false
        this.excelExport(data)

      }, errMsg => {
        this.inOutSaveLoading = false;
        return this.$message.error(errMsg);
      })
    },

    //修复率
    async repairRateExport() {
      if (!this.repairRate.start_time) {
        return this.$message.error('请选择开始时间')
      }
      if (!this.repairRate.end_time) {
        this.repairRate.end_time = new Date()
      }
      let endTime = new Date(this.repairRate.end_time)
      let previousDate = endTime.setDate(this.repairRate.end_time.getDate() - 31)
      if (previousDate > this.repairRate.start_time) {
        return this.$message.error('时间范围不能超过一个月')
      }
      this.repairRateLoading = true
      this.repairRate.is_one = this.componentParam !== 'repair_all_report_export';

      await this.$http('repairReportExportService.repairRateExport', this.repairRate, false).then(data => {
        this.repairRateLoading = false
        this.excelExport(data)

      }, errMsg => {
        this.repairRateLoading = false;
        return this.$message.error(errMsg);
      })
    },
  }
}
</script>

<style scoped>
.input {
  height: 32px;
  width: 200px;
  margin-right: 10px;
}

:deep (.el-date-editor) {
  --el-date-editor-width: 200px;
}

.el-form--inline .el-form-item {
  margin: 0 0 10px 5px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: right;
}

.login-user {
  position: absolute;
  right: 10px;
}

.el-row {
  line-height: 32px;
}

.info-card {
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #dcdfe6;
}

.info-card .el-row {
  display: flex;
}

.item-text {
  text-align: right;
}

.item-value {
  color: goldenrod;
}

.item-value.red-tip {
  color: red;
}

.table-header {
  background-color: #ECECECFF;
}
</style>